import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { throwError } from 'rxjs/internal/observable/throwError';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggingService } from './logging.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { LoggingRequest } from 'src/app/shared/models/log';

export class AbstractService {
  logRequest: LoggingRequest;
  private loggingService: LoggingService;
  private utility: UtilityService;
  constructor(protected http: HttpClient) {
    this.loggingService = new LoggingService(http);
    this.utility = new UtilityService();
  }

  protected postData<T>(
    url: string,
    data: any,
    token: any = null
  ): Observable<T> {
    if (token == null) {
      return this.http
        .post<T>(`api${url}`, data)
        .pipe(catchError(this.handleError));
    } else {
      return this.http
        .post<T>(`api${url}`, data, {
          headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
        })
        .pipe(catchError(this.handleError));
    }
  }

  protected getData<T>(url: string): Observable<T> {
    return this.http.get<T>(`api${url}`).pipe(catchError(this.handleError));
  }

  protected handleError = (error: HttpErrorResponse) => {
    this.logRequest = new LoggingRequest({
      message: this.getErrorMessage(error),
      severity: 'Error',
    });

    if (error == undefined || error.error == undefined) {
      return throwError(() => 'Cannot Get Accuracy');
    }

    return this.loggingService
      .log(this.logRequest)
      .pipe(catchError(() => throwError(() => error.error.message)));
  };

  protected getErrorMessage(error: HttpErrorResponse): string {
    let message = '';
    message = error.message;
    if (!this.utility.isNullOrEmpty(error.error)) {
      message += ' - ' + error.error.title;
      if (!this.utility.isNullOrEmpty(error.error.errors)) {
        message += ':: ' + JSON.stringify(error.error.errors);
      }
    }

    return message;
  }
}
